export function getOS() {
	const ua = navigator.userAgent || '';
	const platform = navigator.platform || '';

	if (/android/i.test(ua)) return 'ANDROID';
	if (/iPad|iPhone|iPod/.test(ua)) return 'IOS';

	if (/Linux/i.test(platform) && /(arm|aarch64)/i.test(ua)) {
		return 'RASPBIAN';
	}

	if (/Win/i.test(platform)) return 'WINDOWS';
	if (/Mac/i.test(platform)) return 'MACOS';
	if (/Linux/i.test(platform)) return 'LINUX';

	return 'UNKNOWN';
}

export function isMobileOS() {
	return ['ANDROID', 'IOS'].includes(getOS());
}

export function isRaspbian() {
	return getOS() === 'RASPBIAN';
}